import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import settingServiceSelectors from '../selectors';
import settingServiceActions from '../actions';

const useGetLoyaltyStampsConfig = (lazy?: boolean) => {
  const dispatch = useAppDispatch();
  const data = settingServiceSelectors.getLoyaltyStampsConfig();

  const mutate = () => {
    dispatch(settingServiceActions.getLoyaltyStampsConfig.fetch());
  };

  useEffect(() => {
    if (!lazy) {
      mutate();
    }
  }, []);

  return { data, mutate } as const;
};

export default useGetLoyaltyStampsConfig;
